<template lang="pug">
  b-container
      .d-flex.align-items-center.mb-4
        v-icon.mr-3(name="brands/paypal", scale="5")
        div
          h5 Integración Paypal
          p Puedes recibir pagos en tu cuenta de Paypal a través de tu Chatbot. Solo tienes que conectar tu aplicación de Paypal con Konverza con tu ID de cliente.
      div(v-if="paypal")
        p.text-secondary Cuenta conectada:
          span.ml-2.text-dark {{paypal.name}}
        b-form(v-if="edit_enabled")
          b-form-group(label="Nombre")
            b-form-input(placeholder="Nombre", v-model="paypal_data.name")
          b-form-group.mb-4(label="Client ID")
            b-form-input(placeholder="Client ID", v-model="paypal_data.client_id")
          b-button.bm-4(variant="success", :disabled="!can_create || loading", @click="updatePaypal")
            span Guardar
            b-spinner.ml-3(v-if="loading", small)
        .d-flex.align-items-center(v-else)
          b-form-group.mb-0.d-inline-block.flex-grow-1
            b-form-input(placeholder="Client ID", v-model="paypal.client_id", readonly)
          edit3-icon.icon-md.hover-primary.pointer.text-secondary.ml-2(@click="edit_enabled = true")
        b-link.mt-3.d-block.text-sm.text-danger(@click="deletePaypal") Eliminar cuenta
      div(v-else)
        p 1. Debes contar con una cuenta de Paypal Business. Inicia sesión en tu cuenta de Paypal Business y dirigite a la seccción de aplicaciones y credenciales. Puedes usar en el siguiente link:
          b-link.ml-2(href="https://developer.paypal.com/developer/applications/", target="_blank") My apps & credentials Paypal
            external-link-icon.icon-sm.ml-2.mb-1
        p 2. Selecciona la opción "Live" para mostrar las aplicaciones activas.
        p 3. Selecciona la aplicación de Paypal que quieras conectar a Konverza, donde recibirás los pagos de tus clientes. Si no tienes aplicaciónes creadas, puedes crear una con la opción de "Create App".
        b-img.mb-4(src="@/assets/tutorial/paypal/app_credentials.png", fluid, rounded, center)
        p 4. En la sección de LIVE API CREDENTIALS podrás ver el Client ID de tu aplicación de Paypal.
        b-img.mb-4(src="@/assets/tutorial/paypal/client_id.png", fluid, rounded, center)
        p 5. Copia todo el texto del Client ID y pega en el siguiente campo de texto.
        b-form-group.mb-4(label="Ingresa Client ID que copiaste:")
          b-form-input(placeholder="Client ID", v-model="paypal_data.client_id")
        p 5. Ingresa un nombre para identificar la integración de Paypal en Konverza y da click en guardar para completar la integración de Konverza con Paypal.
        b-form-group.mb-4(label="Nombre")
          b-form-input(placeholder="Nombre", v-model="paypal_data.name")
        b-button.bm-4(variant="success", :disabled="!can_create || loading", @click="createPaypal")
          span Conectar Paypal
          b-spinner.ml-3(v-if="loading", small)
</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex'
const paypalController = createNamespacedHelpers('paypal')

export default {
  data () {
    return {
      loading: false,
      paypal_modal: false,
      edit_enabled: false,
      paypal_data: {
        name: "",
        client_id: ""
      }
    }
  },
  computed: {
    ...paypalController.mapState({
      paypals: state => state.paypals,
    }),
    paypal () {
      return this.paypals.length ? this.paypals[0] : null
    },
    can_create () {
      return !!(this.paypal_data.name && this.paypal_data.client_id)
    }
  },
  methods: {
    ...mapActions(['paypal/all', 'paypal/create', 'paypal/update', 'paypal/destroy']),
    getPaypal () {
      let self = this
      this.showLoadingScreen();

      this['paypal/all']({
        account_id: self.$route.params.account_id,
        callback: res => {
          this.hideLoadingScreen();
          if (res.error) {
            self.$message.error(res.error)
          } else {
            if(self.paypal) self.paypal_data = Object.assign(self.paypal)
          }
        }
      })
    },
    createPaypal () {
      let self = this
      this.loading = true

      this['paypal/create']({
        account_id: self.$route.params.account_id,
        ...self.paypal_data,
        callback: res => {
          this.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.$message.success("Integración de Paypal exitosa.")
          }
        }
      })
    },
    updatePaypal () {
      let self = this
      this.loading = true;

      this['paypal/update']({
        ...self.paypal_data,
        callback: res => {
          self.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.edit_enabled = false
            self.$message.success("Información actualizada.")
          }
        }
      })
    },
    async deletePaypal () {
      try {
        let response = await this.$bvModal.msgBoxConfirm(`¿Deseas eliminar tu cuenta de Paypal en Konverza? No se puede deshacer.`, {
          title: 'Eliminar',
          okVariant: 'danger',
          okTitle: 'Eliminar',
          cancelTitle: 'Cancelar'
        })
        if (response) {
          let self = this
          this.loading = true;

          this['paypal/destroy']({
            account_id: self.$route.params.account_id,
            paypal_id: self.paypal.paypal_id,
            callback: res => {
              self.loading = false
              if (res.error) {
                self.$message.error(res.error)
              }
            }
          })
        }
      } catch (e) {
        console.error(e.message);
      }
    }
  },
  mounted() {
    this.getPaypal()
  }
}
</script>

<style lang="scss">

</style>